import { useState, useEffect } from 'react';
import { FaArrowLeft, FaQuestionCircle, FaCheckCircle, FaTrophy, FaChevronUp } from 'react-icons/fa';
import Preguntas from './Preguntas/Preguntas';
import Respuestas from './Respuestas/Respuestas';
import Resultados from './Resultados/Resultados';
import styles from './VerTest.module.css'; 

const VerTest = ({ test, onBack }) => {
    const [activeSection, setActiveSection] = useState('preguntas');
    const [currentPage, setCurrentPage] = useState(1);
    const preguntasPorPagina = 10;
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 300) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    if (!test) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContainer}> 
                <p className={styles.loadingText}> Error al cargar test :( </p>
                </div>
            </div>
            );
    }

    const renderContent = () => {
        switch (activeSection) {
            case 'preguntas':
                return (
                        <Preguntas
                            testId={test.te_clave}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            preguntasPorPagina={preguntasPorPagina}
                        />
                );
            case 'respuestas':
                return (
                        <Respuestas testId={test.te_clave} />
                );
            case 'resultados':
                return (
                        <Resultados testId={test.te_clave} />
                );
            default:
                return null;
        }
    };

    return (
        <div className={styles.verTestContainer}>
            <button className={styles.btnBack} onClick={onBack}>
                <FaArrowLeft /> Volver a test
            </button>
            
            <div className={styles.verTestHeader}>
                <div className={styles.testInfo}>
                    <h1>{test.te_nombre}</h1>
                    <p>{test.te_descripcion}</p>
                    {test.te_tiempo_estimado && (
                        <span className={styles.testDuration}>
                            Duración estimada: {test.te_tiempo_estimado} minutos
                        </span>
                    )}
                </div>
            </div>

            {/* Navegación de secciones */}
            <div className={styles.sectionNavigation}>
                <button
                    className={`${styles.navBtn} ${activeSection === 'preguntas' ? styles.active : ''}`}
                    onClick={() => {
                        setActiveSection('preguntas');
                        setCurrentPage(1);
                    }}
                >
                    <FaQuestionCircle /> Preguntas
                </button>
                <button
                    className={`${styles.navBtn} ${activeSection === 'respuestas' ? styles.active : ''}`}
                    onClick={() => setActiveSection('respuestas')}
                >
                    <FaCheckCircle /> Respuestas
                </button>
                <button
                    className={`${styles.navBtn} ${activeSection === 'resultados' ? styles.active : ''}`}
                    onClick={() => setActiveSection('resultados')}
                >
                    <FaTrophy /> Resultados
                </button>
            </div>

            {/* Sección activa */}
            <div className={styles.sectionContainer}>
                {renderContent()}
            </div>

            {/* Flecha flotante para volver al inicio */}
            {showScrollTop && (
                <button
                    className={styles.scrollToTopBtn}
                    onClick={scrollToTop}
                    title="Volver al inicio"
                    aria-label="Volver al inicio de la página"
                >
                    <FaChevronUp />
                </button>
            )}
        </div>
    );
};

export default VerTest;